import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import CashoutAgentForm from '../../components/forms/CashoutAgentForm/CashoutAgentForm';

const CashoutAgent = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="cashout-agent">
      <CashoutAgentForm userId={uid} />
    </AuthLayout>
  );
};

export default CashoutAgent;
